"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMegaMenuArticles = exports.defaultMegaMenuArticle1 = void 0;
exports.defaultMegaMenuArticle1 = {
    image: 'https://images.okay.com/Property/HQ/olympian-mansion-mid-levels-west-for-sale-41830_637611772160997398.jpg',
    title: 'The Many Ways a Real Estate Agent Can Help with Your Home Purchase',
    url: 'http://google.com',
};
exports.defaultMegaMenuArticles = [exports.defaultMegaMenuArticle1, exports.defaultMegaMenuArticle1, exports.defaultMegaMenuArticle1, exports.defaultMegaMenuArticle1];
